var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BroadcastMessage'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-7"},[_c('LoginContent')],1),_c('div',{staticClass:"col-md-5"},[_c('LoginForm')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }